import { render, staticRenderFns } from "./EzAccountMenu.vue?vue&type=template&id=397dc8e8&scoped=true&"
import script from "./EzAccountMenu.vue?vue&type=script&lang=js&"
export * from "./EzAccountMenu.vue?vue&type=script&lang=js&"
import style0 from "./EzAccountMenu.vue?vue&type=style&index=0&id=397dc8e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397dc8e8",
  null
  
)

export default component.exports